import { render, staticRenderFns } from "./ObjectTypesSidebar.vue?vue&type=template&id=087faef2&scoped=true&"
import script from "./ObjectTypesSidebar.vue?vue&type=script&lang=js&"
export * from "./ObjectTypesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ObjectTypesSidebar.vue?vue&type=style&index=0&id=087faef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087faef2",
  null
  
)

export default component.exports